<div class="task-history-tab">
  <!-- Loading Indicator -->
  @if (requestIsInProgress && (!history || history.length === 0)) {
    <div
      class="d-flex justify-content-center align-items-center p-3">
      <div class="spinner-border text-dark" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <!-- Timeline with events -->
  @if (history && history.length > 0) {
    <div class="history-timeline">
      <!-- Timeline connector line -->
      <div class="timeline-line"></div>
      <!-- Timeline events -->
      <div class="timeline-events">
        @for (item of history; track item; let last = $last) {
          <div class="timeline-event" [class.timeline-event-last]="last">
            <!-- Event icon circle -->
            <div class="event-icon" [ngClass]="getEventIconClass(item.action)">
              <mat-icon class="icon">{{ getEventIcon(item.action) }}</mat-icon>
            </div>
            <!-- Event content card -->
            <div class="event-content">
              <div class="event-header">
                <div class="event-user-action">
                  <span class="event-user">{{ item.user }}</span>
                  <span class="event-separator">•</span>
                  <span class="event-action">{{ formatAction(item.action) }}</span>
                </div>
                <span class="event-timestamp">{{ formatEventTime(item.timestamp) }}</span>
              </div>
              @if (item.details) {
                <div class="event-description">
                  {{ item.details }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Load More Button -->
  @if (showLoadMoreOption && !(requestIsInProgress && (!history || history.length === 0))) {
    <div class="load-more-wrapper">
      <button type="button" class="load-more-btn" (click)="loadMoreData()" [disabled]="requestIsInProgress">
        @if (!requestIsInProgress) {
          Load More
        } @else {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span>Loading...</span>
        }
      </button>
    </div>
  }
  <!-- Empty state -->
  @if (!requestIsInProgress && (!history || history.length === 0)) {
    <div class="empty-state">
      <mat-icon class="empty-icon">history</mat-icon>
      <p class="empty-text">No activity yet</p>
      <p class="empty-subtext">Task history will appear here</p>
    </div>
  }
</div>